<template>
  <div>
    <div class="d-flex">
      <div
        class="flex-grow-1 d-flex"
        :class="{
          'flex-wrap': canShowInSearch && !disableCreate,
        }"
      >
        <div
          :class="{
            'flex-grow-0 pr-4 pt-1': canShowInSearch,
            'flex-grow-1': !canShowInSearch,
          }"
          style="max-width: 800px; min-width: 250px"
          v-if="!disableSearch"
        >
          <v-text-field
            v-model="params.search"
            clearable
            dense
            hide-details
            outlined
            :placeholder="placeholder"
            prepend-inner-icon="mdi-magnify"
            single-line
          />
        </div>
        <div
          v-if="canShowInSearch && !isMobile"
          class="flex-grow-1 d-flex pt-1"
        >
          <slot />
        </div>
      </div>
      <slot name="extra-btn" />
      <div
        v-if="!disableCreate"
        class="flex-grow-0"
        :class="{
          'pt-1': canShowInSearch,
        }"
      >
        <div class="pl-2" style="width: 160px">
          <base-button
            block
            type-action="create"
            @click="onCreateItem()"
          ></base-button
        ></div>
      </div>
    </div>
    <div
      v-if="$slots['default'] && (!canShowInSearch || isMobile)"
      class="pa-4 mt-4 pb-md-0"
      style="background: #f3f6f9"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    disableCreate: Boolean,
    placeholder: { type: String, default: 'Tìm kiếm' },
    canShowInSearch: Boolean,
    disableSearch: Boolean,
  },
  data: () => ({}),
  computed: {
    params: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onCreateItem() {
      this.$emit('click:create')
    },
  },
}
</script>

<style scoped></style>
